export default "/assets/thread_loading-c24f39910d6693033cb9adc3a12fb203f2b6bcdb5dc3645d1b277012acd54e09.svg";